// extracted by mini-css-extract-plugin
module.exports = {"input":"TagInputUI__input___1yNCM","button":"TagInputUI__button___1R9Ft","tags-container":"TagInputUI__tags-container___3NwHO","tag":"TagInputUI__tag___1ppYr"};